/* Moringa Magic 3D bottle. Progressive enhancement: the static bottle stays unless WebGL,
   dynamic import and the label texture all succeed. */
(function () {
  'use strict';
  var holders = document.querySelectorAll('[data-mm-bottle]');
  if (!holders.length) return;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function hasWebGL() {
    try {
      var c = document.createElement('canvas');
      return !!(window.WebGLRenderingContext && (c.getContext('webgl2') || c.getContext('webgl') || c.getContext('experimental-webgl')));
    } catch (e) { return false; }
  }
  var dynImport;
  try { dynImport = new Function('u', 'return import(u)'); } catch (e) { dynImport = null; }
  if (!hasWebGL() || !dynImport || !window.MM_THREE_URL) return;

  dynImport(window.MM_THREE_URL).then(function (THREE) {
    for (var i = 0; i < holders.length; i++) setup(THREE, holders[i]);
  }).catch(function (e) { if (window.console) console.warn('mm-bottle: 3D fallback', e); });

  // Soft studio: a neutral room with large emissive softboxes, baked to an environment map.
  function studioEnv(THREE, renderer) {
    var scene = new THREE.Scene();
    var box = new THREE.BoxGeometry(1, 1, 1);
    var room = new THREE.Mesh(box, new THREE.MeshBasicMaterial({ color: 0x3c3b37, side: THREE.BackSide }));
    room.scale.set(24, 14, 24); room.position.y = 4; scene.add(room);
    function panel(w, h, x, y, z, rx, ry, intensity, tint) {
      var c = new THREE.Color(tint || 0xffffff).multiplyScalar(intensity);
      var m = new THREE.Mesh(new THREE.PlaneGeometry(w, h), new THREE.MeshBasicMaterial({ color: c, side: THREE.DoubleSide }));
      m.position.set(x, y, z); m.rotation.set(rx || 0, ry || 0, 0); scene.add(m);
    }
    panel(10, 6, 0, 10.5, 0, Math.PI / 2, 0, 3.6);                 // overhead softbox
    panel(2.2, 9, -9, 4, 3, 0, Math.PI / 2.4, 9);                  // tall strip, left
    panel(2.2, 9, 9, 4, 2, 0, -Math.PI / 2.4, 5);                  // tall strip, right
    panel(6, 4, 2, 3, 11, 0, Math.PI, 1.3, 0xfff3dc);              // warm front fill
    panel(6, 3, 0, 2, -11, 0, 0, 1.4, 0xe2f5d6);                   // green-tinted back rim
    var pmrem = new THREE.PMREMGenerator(renderer);
    var tex = pmrem.fromScene(scene, 0.035).texture;
    pmrem.dispose();
    return tex;
  }

  // Fine noise used as a bump map so the plastic reads as moulded HDPE, not flat CG.
  function noiseTex(THREE) {
    var c = document.createElement('canvas'); c.width = c.height = 256;
    var g = c.getContext('2d'), d = g.createImageData(256, 256);
    for (var i = 0; i < d.data.length; i += 4) { var v = 118 + Math.random() * 20; d.data[i] = d.data[i + 1] = d.data[i + 2] = v; d.data[i + 3] = 255; }
    g.putImageData(d, 0, 0);
    var t = new THREE.CanvasTexture(c); t.wrapS = t.wrapT = THREE.RepeatWrapping; t.repeat.set(6, 6); return t;
  }

  // Knurled cap: vertical ribs as a normal-ish bump stripe texture.
  function ribTex(THREE, count) {
    var c = document.createElement('canvas'); c.width = 2048; c.height = 8;
    var g = c.getContext('2d'), w = c.width / count;
    for (var i = 0; i < count; i++) {
      var grad = g.createLinearGradient(i * w, 0, (i + 1) * w, 0);
      grad.addColorStop(0, '#5a5a5a'); grad.addColorStop(0.5, '#d8d8d8'); grad.addColorStop(1, '#5a5a5a');
      g.fillStyle = grad; g.fillRect(i * w, 0, w, 8);
    }
    var t = new THREE.CanvasTexture(c); t.wrapS = THREE.RepeatWrapping; return t;
  }

  function lathe(THREE, pts, mat, seg) {
    var v = [];
    for (var i = 0; i < pts.length; i++) v.push(new THREE.Vector2(pts[i][0], pts[i][1]));
    var geo = new THREE.LatheGeometry(v, seg || 96);
    return new THREE.Mesh(geo, mat);
  }

  function setup(THREE, holder) {
    var kind = holder.getAttribute('data-kind') || 'capsule';
    var labelUrl = holder.getAttribute('data-label');
    var capColor = holder.getAttribute('data-cap') || '#F4F3EE';
    var auto = holder.getAttribute('data-autorotate') !== 'false' && !reduced;
    if (!labelUrl) return;

    var loader = new THREE.TextureLoader();
    loader.setCrossOrigin('anonymous');
    loader.load(labelUrl, function (tex) { build(THREE, holder, kind, tex, capColor, auto); }, undefined, function () {});
  }

  function build(THREE, holder, kind, tex, capColor, auto) {
    var renderer;
    try {
      renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true, powerPreference: 'high-performance' });
    } catch (e) { return; }
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2.5));
    renderer.outputColorSpace = THREE.SRGBColorSpace;
    renderer.toneMapping = THREE.NeutralToneMapping !== undefined ? THREE.NeutralToneMapping : THREE.ACESFilmicToneMapping;
    renderer.toneMappingExposure = 1.07;
    var canvas = renderer.domElement;
    canvas.className = 'mm-bottle__canvas';
    canvas.setAttribute('aria-hidden', 'true');

    var scene = new THREE.Scene();
    var camera = new THREE.PerspectiveCamera(26, 1, 0.1, 100);
    camera.position.set(0, 0.3, 10);
    camera.lookAt(0, 0, 0);

    scene.environment = studioEnv(THREE, renderer);
    scene.add(new THREE.HemisphereLight(0xffffff, 0xd6dccb, 0.25));
    var key = new THREE.DirectionalLight(0xffffff, 1.35); key.position.set(4, 5, 4); scene.add(key);
    var rim = new THREE.DirectionalLight(0xe6ffd8, 0.6); rim.position.set(-3, 3, -5); scene.add(rim);

    tex.colorSpace = THREE.SRGBColorSpace;
    tex.anisotropy = renderer.capabilities.getMaxAnisotropy();
    tex.wrapS = THREE.RepeatWrapping;

    var group = new THREE.Group();
    scene.add(group);

    var noise = noiseTex(THREE);
    var plastic = new THREE.MeshPhysicalMaterial({ color: 0xf6f5f0, roughness: 0.3, metalness: 0, clearcoat: 0.6, clearcoatRoughness: 0.22, bumpMap: noise, bumpScale: 0.6, sheen: 0.25, sheenRoughness: 0.6, sheenColor: new THREE.Color(0xffffff) });
    var ribs = ribTex(THREE, 110);
    var capMat = new THREE.MeshPhysicalMaterial({ color: new THREE.Color(capColor), roughness: 0.42, metalness: 0, clearcoat: 0.25, clearcoatRoughness: 0.4, bumpMap: ribs, bumpScale: 6 });
    var capTopMat = new THREE.MeshPhysicalMaterial({ color: new THREE.Color(capColor), roughness: 0.32, metalness: 0, clearcoat: 0.55, clearcoatRoughness: 0.25, bumpMap: noise, bumpScale: 0.4 });
    var labelMat = new THREE.MeshPhysicalMaterial({ map: tex, roughness: 0.38, metalness: 0, clearcoat: 0.4, clearcoatRoughness: 0.18 });
    tex.generateMipmaps = true; tex.minFilter = THREE.LinearMipmapLinearFilter; tex.magFilter = THREE.LinearFilter;

    if (kind === 'elixir') {
      var glass = new THREE.MeshPhysicalMaterial({ color: 0x5e2c02, roughness: 0.06, metalness: 0, clearcoat: 1, clearcoatRoughness: 0.05 });
      var r = 0.8;
      group.add(lathe(THREE, [[0, -1.8], [r - 0.08, -1.8], [r, -1.7], [r, 0.95], [r - 0.1, 1.15], [0.55, 1.32], [0.4, 1.4], [0.4, 1.7], [0, 1.7]], glass, 96));
      var labelH = (2 * Math.PI * (r + 0.012)) / 2;
      var lab = new THREE.Mesh(new THREE.CylinderGeometry(r + 0.012, r + 0.012, labelH, 256, 1, true), labelMat);
      lab.position.y = -0.35; lab.rotation.y = Math.PI; group.add(lab);
      var dropCap = new THREE.MeshPhysicalMaterial({ color: 0x151515, roughness: 0.42, clearcoat: 0.3, clearcoatRoughness: 0.4, bumpMap: ribs, bumpScale: 4 });
      var rubber = new THREE.MeshPhysicalMaterial({ color: 0x121212, roughness: 0.32, clearcoat: 0.7, clearcoatRoughness: 0.25 });
      var c1 = new THREE.Mesh(new THREE.CylinderGeometry(0.5, 0.5, 0.36, 180, 1, true), dropCap); c1.position.y = 1.83; group.add(c1);
      group.add(lathe(THREE, [[0.5, 1.65], [0.47, 1.645], [0, 1.645]], dropCap, 128));
      group.add(lathe(THREE, [[0.5, 2.01], [0.47, 2.03], [0.47, 2.07], [0.43, 2.09], [0.43, 2.36], [0.36, 2.4], [0, 2.4]], rubber, 128));
      var c2 = new THREE.Mesh(new THREE.CylinderGeometry(0.43, 0.43, 0.27, 160, 1, true), dropCap); c2.position.y = 2.225; group.add(c2);
      group.add(lathe(THREE, [[0, 2.39], [0.27, 2.39], [0.285, 2.46], [0.25, 2.58], [0.255, 2.75], [0.285, 2.98], [0.285, 3.15], [0.25, 3.29], [0.17, 3.37], [0.08, 3.405], [0, 3.41]], rubber, 128));
      group.position.y = -0.62;
    } else {
      var R = 1.0;
      group.add(lathe(THREE, [[0, -1.95], [R - 0.16, -1.95], [R - 0.06, -1.935], [R - 0.015, -1.9], [R, -1.84], [R, 0.98], [R - 0.01, 1.06], [R - 0.04, 1.15], [R - 0.1, 1.25], [R - 0.19, 1.34], [R - 0.29, 1.41], [0.62, 1.46], [0.6, 1.49], [0.6, 1.52], [0.67, 1.53], [0.68, 1.56], [0.67, 1.59], [0.6, 1.6], [0.6, 1.66], [0, 1.66]], plastic, 160));
      var lh = (2 * Math.PI * (R + 0.012)) / 3;
      var label = new THREE.Mesh(new THREE.CylinderGeometry(R + 0.012, R + 0.012, lh, 256, 1, true), labelMat);
      label.position.y = -0.46; label.rotation.y = Math.PI; group.add(label);
      var capSide = new THREE.Mesh(new THREE.CylinderGeometry(0.705, 0.705, 0.4, 240, 1, true), capMat);
      capSide.position.y = 1.83; group.add(capSide);
      group.add(lathe(THREE, [[0.705, 1.63], [0.69, 1.625], [0, 1.625]], capTopMat, 160));
      group.add(lathe(THREE, [[0.705, 2.03], [0.705, 2.08], [0.69, 2.1], [0.64, 2.115], [0, 2.118]], capTopMat, 160));
      group.position.y = -0.1;
    }

    // interaction
    var dragging = false, lastX = 0, lastY = 0, vel = 0, tiltX = 0, rotY = -0.25, t0 = performance.now();
    var speed = auto ? 0.35 : 0;
    function onDown(e) { dragging = true; lastX = e.clientX; lastY = e.clientY; vel = 0; canvas.setPointerCapture && canvas.setPointerCapture(e.pointerId); holder.classList.add('is-grabbing'); }
    function onMove(e) {
      if (!dragging) return;
      var dx = e.clientX - lastX, dy = e.clientY - lastY; lastX = e.clientX; lastY = e.clientY;
      rotY += dx * 0.012; vel = dx * 0.012; tiltX = Math.max(-0.35, Math.min(0.35, tiltX + dy * 0.004));
    }
    function onUp() { dragging = false; holder.classList.remove('is-grabbing'); }
    canvas.addEventListener('pointerdown', onDown);
    window.addEventListener('pointermove', onMove, { passive: true });
    window.addEventListener('pointerup', onUp);
    window.addEventListener('pointercancel', onUp);

    function resize() {
      var w = holder.clientWidth || 300, h = holder.clientHeight || w;
      renderer.setSize(w, h, false);
      camera.aspect = w / h; camera.updateProjectionMatrix();
      renderer.render(scene, camera);
    }
    resize();
    if (window.ResizeObserver) new ResizeObserver(resize).observe(holder); else window.addEventListener('resize', resize);

    var visible = true;
    if (window.IntersectionObserver) {
      new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }, { rootMargin: '100px' }).observe(holder);
    }

    function frame(now) {
      requestAnimationFrame(frame);
      if (!visible || document.hidden) return;
      var dt = Math.min(0.05, (now - t0) / 1000); t0 = now;
      if (!dragging) { rotY += speed * dt + vel; vel *= 0.92; tiltX += (0 - tiltX) * 0.06; }
      group.rotation.y = rotY; group.rotation.x = tiltX;
      group.position.y = (kind === 'elixir' ? -0.62 : -0.1) + (reduced ? 0 : Math.sin(now / 900) * 0.06);
      renderer.render(scene, camera);
    }

    holder.appendChild(canvas);
    renderer.render(scene, camera);
    holder.classList.add('is-3d');
    requestAnimationFrame(frame);
  }
})();
